module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074cc_banner_800x600.7cd4b0e8.png";